<mat-dialog-content>
  <p>
    Use your device camera to scan a barcode for a hire item or retail product.
  </p>
  @if (devices.length > 1) {
  <button mat-button (click)="viewOtherCameras = !viewOtherCameras">
    Change camera
  </button>
  @if (viewOtherCameras) {
  <mat-form-field>
    <mat-label>Camera</mat-label>
    <mat-select (selectionChange)="onDeviceSelect($event)">
      <mat-option *ngFor="let device of devices" [value]="device">
        {{ device.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  }
  }

  <!-- For camera -->
  <ngx-scanner-qrcode [vibrate]="0" #action="scanner"></ngx-scanner-qrcode>
</mat-dialog-content>